import { SET, SET_LOADING } from "./Actions";

const initialState = {
  general: null,
  seo: null,
  slider_menus: null,
  widgets: [],
  socials: null,
  contact_info: null,
  other: null,
  verification_texts: null,
  gateways: null,
  loading: false,
};

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET:
      return {
        ...state,
        ...action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload.loading,
      };

    default:
      return state;
  }
};

export default settingsReducer;
